export default "__VITE_ASSET__BHCPuKHt__"